<template>
    <div>
        <div v-if="txDetails" class="mobile-tx-value">
            <span v-if="txDetails.event === 'received_ton' || txDetails.event === 'sent_ton'" v-bind:class="{'ui-inline-jetton--green': traceStatus}">
                {{ $ton(txDetails.amount) }} TON
            </span>
            <span v-else-if="txDetails.event === 'nft_transfer' || txDetails.event === 'nft_purchase'" v-bind:class="{'ui-inline-jetton--green': traceStatus}">
                {{ txDetails.meta.name }}
            </span>
            <span v-else-if="txDetails.event === 'sent_jetton' || txDetails.event === 'received_jetton' || txDetails.event === 'jetton_burn'">
                <ui-inline-jetton
                    v-bind:address="txDetails.meta?.jetton_address"
                    v-bind:decimals="txDetails.meta?.decimals"
                    v-bind:symbol="txDetails.meta?.symbol"
                    v-bind:value="txDetails.amount || txDetails.action.amount"
                    v-bind:showSign="false"
                />
            </span>
            <span class="mobile-tx-value--swap" v-else-if="txDetails.event === 'jetton_swap'">
                <inline-swap v-bind:meta="txDetails.meta" v-bind:round="true" />
            </span>
            <span v-else v-bind:class="{'ui-inline-jetton--green': traceStatus}">
                {{ $t(`events.${txDetails.event}`) }}
            </span>
        </div>
        <span v-else class="mobile-tx-value skeleton skeleton--inline">12345678blablabla ton</span>

        <div class="mobile-tx-value--message-container">
            <div v-if="txDetails?.message" class="mobile-tx-value--message">
                {{ txDetails.message }}
            </div>
        </div>
    </div>
</template>

<script>
import InlineSwap from '~/components/address/TxRowInlineSwap.vue';
import UiInlineJetton from '~/components/address/TxRowInlineJetton.vue';

export default {
    components: { UiInlineJetton, InlineSwap },
    props: ['traceActions', 'traceStatus'],
    computed: {
        txDetails() {
            if (!this.traceActions) return null;

            if (this.traceActions[0]?.simple_preview) {
                return this.traceActions[0]?.simple_preview;
            }
            return this.traceActions[0];
        },
    },
};
</script>

<style lang="scss">
.mobile-tx-value {
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    text-align: center;
    font-size: 24px;
    font-family: Nunito,Rubik,Roboto,Ubuntu,Arial,sans-serif;
    font-weight: 800;
    margin-top: 4px;
    margin-bottom: 6px;

    &--message {
        display: inline-flex;
        width: auto;
        max-width: 100%;
        box-sizing: border-box;
        background-color: var(--body-light-muted-color);
        padding: 8px 14px 8px 12px;
        border-radius: 15px 15px 15px 3px;
        white-space: normal;
        overflow-wrap: anywhere;
        position: relative;
        line-height: 1.4;
        margin: 12px 12px 8px 12px;
    }

    &--message-container {
        width: 100%;
        max-width: 100%;
        display: flex;
        justify-content: center;
    }

    &--swap {
        text-transform: capitalize;
        font-size: clamp(16px, 4.3dvw, 20px);
    }
}
</style>
